import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  datetime_from: d.startOf('day').format(),
  datetime_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'datetime', title: t('grid.Дата и время'), change },
    { type: 'input', name: 'name', title: t('form.Клиент'), placeholder: t('form.Клиент'), w: 220 },
    { type: 'doublenumber', name: 'amount', title: t('grid.Сумма, ₽'), w: 80 },
    { type: 'input', name: 'fn', title: t('form.Номер ФН'), placeholder: t('form.Номер ФН'), withoutLetters: true },
    { type: 'parking' },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'discountFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
